export default {
  getProducts: state => state.products,
  getProduct: state => state.product,
  pagesCount: (state) => state.pagesCount,
  totalCountData: (state) => state.totalCountData,
  getCurrencies: (state) => state.currencies
}